import { render, staticRenderFns } from "./DeliveriesBulkAssignPartnerModal.vue?vue&type=template&id=05d5cc8a&lang=pug&"
import script from "./DeliveriesBulkAssignPartnerModal.vue?vue&type=script&lang=js&"
export * from "./DeliveriesBulkAssignPartnerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports